/** Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState, useEffect } from "react"

import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import colors from 'tailwindcss/colors'

import Header from "./header-alt"
import Footer from "./footer"

const Layout = ({ children }) => {
  const [index, setIndex] = useState(0)
  const [bottomIndex, setBottomIndex] = useState(1);
  const [isFading, setIsFading] = useState(false); // New state for transition trigger


  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      slides: allFile(
      sort: {name: DESC}, filter: {relativeDirectory: {eq: "slides"}}
      ) {
        edges {
          node {
            id
            name
            childImageSharp {
              gatsbyImageData(
                  width: 2464
                  quality: 95
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
              )
            }
          }
        }
      }
      banner: file(
        relativePath: {eq: "hooman-r-5YI5H-2xUU0-unsplash.jpg"}) {
        childImageSharp {
            gatsbyImageData(
                width: 2464
                quality: 95
                placeholder: BLURRED
                formats: [AUTO, WEBP]
            )
        }
      }
    }
  `)

  const shuffledSlides = React.useMemo(() => {
    const slides = [...data.slides.edges]; // Copy to avoid mutating original data
    for (let i = slides.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [slides[i], slides[j]] = [slides[j], slides[i]];
    }
    return slides;
  }, [data.slides.edges]);


  const length = shuffledSlides.length;


  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsFading(true);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % length);
        setIsFading(false);

        setTimeout(() => {
          setBottomIndex((prev) => (prev + 1) % length);
        }, 100);
      }, 1000);
    }, 6000);

    return () => clearInterval(intervalId);
  }, [length]);

  return (
    <div>
      <div className={`transition-color duration-300 dark:bg-neutral-700 dark:text-neutral-100 min-h-screen`}>

        <div className="relative w-full h-[24rem] mb-12 overflow-hidden bg-black border-b-8 border-emerald-300 dark:border-emerald-400">
          <div className="absolute inset-0 z-0">
            <GatsbyImage
              image={shuffledSlides[bottomIndex].node.childImageSharp.gatsbyImageData}
              className="w-full h-full"
              alt=""
            />
          </div>

          <div className={`absolute inset-0 z-10 transition-opacity ease-in-out ${isFading ? 'opacity-0 duration-1000' : 'opacity-100 duration-0'
            }`}>
            <GatsbyImage
              image={shuffledSlides[index].node.childImageSharp.gatsbyImageData}
              className="w-full h-full"
              alt=""
            />
          </div>
        </div>

        <div className="w-full h-[12rem] absolute top-0 z-10 bg-gradient-to-b from-neutral-800 to-transparent opacity-70"></div>
        <div className="absolute w-full top-0 z-20">
          <Header siteTitle={data.site.siteMetadata.title} />
        </div>
        <div
          className="container max-w-6xl mx-auto px-4"
        >
          <main className="block min-h-screen pb-48">{children}</main>
        </div>
        <Footer />
      </div>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" style={{ position: "absolute", width: 0, height: 0 }} width="0" height="0">
        <defs>
          <symbol id="icon-dark-mode" viewBox="0 0 24 24">
            <title>Dark Mode</title>
            <path d="M12,3c-4.97,0-9,4.03-9,9s4.03,9,9,9s9-4.03,9-9c0-0.46-0.04-0.92-0.1-1.36c-0.98,1.37-2.58,2.26-4.4,2.26 c-2.98,0-5.4-2.42-5.4-5.4c0-1.81,0.89-3.42,2.26-4.4C12.92,3.04,12.46,3,12,3L12,3z" />
          </symbol>
        </defs>
      </svg>

      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" style={{ position: "absolute", width: 0, height: 0 }} width="0" height="0">
        <defs>
          <symbol id="icon-light-mode" viewBox="0 0 24 24">
            <title>Light Mode</title>
            <path d="M12,7c-2.76,0-5,2.24-5,5s2.24,5,5,5s5-2.24,5-5S14.76,7,12,7L12,7z M2,13l2,0c0.55,0,1-0.45,1-1s-0.45-1-1-1l-2,0 c-0.55,0-1,0.45-1,1S1.45,13,2,13z M20,13l2,0c0.55,0,1-0.45,1-1s-0.45-1-1-1l-2,0c-0.55,0-1,0.45-1,1S19.45,13,20,13z M11,2v2 c0,0.55,0.45,1,1,1s1-0.45,1-1V2c0-0.55-0.45-1-1-1S11,1.45,11,2z M11,20v2c0,0.55,0.45,1,1,1s1-0.45,1-1v-2c0-0.55-0.45-1-1-1 C11.45,19,11,19.45,11,20z M5.99,4.58c-0.39-0.39-1.03-0.39-1.41,0c-0.39,0.39-0.39,1.03,0,1.41l1.06,1.06 c0.39,0.39,1.03,0.39,1.41,0s0.39-1.03,0-1.41L5.99,4.58z M18.36,16.95c-0.39-0.39-1.03-0.39-1.41,0c-0.39,0.39-0.39,1.03,0,1.41 l1.06,1.06c0.39,0.39,1.03,0.39,1.41,0c0.39-0.39,0.39-1.03,0-1.41L18.36,16.95z M19.42,5.99c0.39-0.39,0.39-1.03,0-1.41 c-0.39-0.39-1.03-0.39-1.41,0l-1.06,1.06c-0.39,0.39-0.39,1.03,0,1.41s1.03,0.39,1.41,0L19.42,5.99z M7.05,18.36 c0.39-0.39,0.39-1.03,0-1.41c-0.39-0.39-1.03-0.39-1.41,0l-1.06,1.06c-0.39,0.39-0.39,1.03,0,1.41s1.03,0.39,1.41,0L7.05,18.36z" />
          </symbol>
        </defs>
      </svg>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" style={{ position: "absolute", width: 0, height: 0 }} width="0" height="0">
        <defs>
          <symbol id="logo" viewBox="0 0 987 237">
            <path d="M971.376,154.947C971.376,154.947 980.372,173.728 980.372,181.581C980.372,186.548 976.339,190.581 971.376,190.581C966.405,190.581 962.373,186.548 962.373,181.581C962.373,173.728 971.376,154.947 971.376,154.947ZM958.854,178.954C953.894,178.946 949.87,174.916 949.87,169.954C949.87,162.101 958.87,143.32 958.87,143.32C958.87,143.32 962.74,151.397 965.405,159.171C963.03,164.783 959.748,173.227 958.854,178.954Z" style={{ fill: "rgb(0,196,229)" }} />
            <path d="M115.036,92.721L115.036,110.686L158.751,110.686L158.751,137.333L115.036,137.333L115.036,170.868L79.706,170.868L79.706,66.073L164.889,66.073L164.889,92.721L115.036,92.721ZM259.953,116.075C266.091,118.321 270.881,121.764 274.324,126.105C277.768,130.447 279.414,135.836 279.414,141.974C279.414,151.106 275.672,158.292 268.037,163.233C260.402,168.323 249.473,170.868 235.101,170.868L176.117,170.868L176.117,66.073L232.107,66.073C246.03,66.073 256.659,68.618 263.845,73.558C270.881,78.499 274.474,85.235 274.474,93.469C274.474,98.41 273.276,102.751 270.881,106.644C268.336,110.536 264.743,113.68 259.953,116.075ZM210.849,90.775L210.849,106.344L227.316,106.344C234.951,106.344 238.844,103.799 238.844,98.559C238.844,93.32 234.951,90.775 227.316,90.775L210.849,90.775ZM232.107,146.166C239.892,146.166 243.784,143.471 243.784,137.932C243.784,132.393 239.892,129.698 232.107,129.698L210.849,129.698L210.849,146.166L232.107,146.166ZM385.407,170.868L385.107,123.111L362.352,161.436L346.782,161.436L324.027,124.758L324.027,170.868L291.84,170.868L291.84,66.073L320.883,66.073L355.016,121.914L388.251,66.073L417.294,66.073L417.594,170.868L385.407,170.868ZM484.812,173.263C468.794,173.263 456.218,168.922 447.236,160.239C438.254,151.556 433.762,139.429 433.762,123.71L433.762,66.073L469.093,66.073L469.093,122.662C469.093,130.297 470.441,135.986 473.285,139.429C475.98,142.873 479.872,144.669 485.112,144.669C490.352,144.669 494.244,142.873 496.939,139.429C499.783,135.986 501.131,130.297 501.131,122.662L501.131,66.073L535.863,66.073L535.863,123.71C535.863,139.429 531.371,151.556 522.389,160.239C513.407,168.922 500.831,173.263 484.812,173.263ZM552.031,66.073L603.68,66.073C615.357,66.073 625.686,68.169 634.669,72.361C643.502,76.702 650.538,82.69 655.478,90.625C660.418,98.559 662.814,107.841 662.814,118.47C662.814,129.1 660.418,138.381 655.478,146.316C650.538,154.25 643.502,160.239 634.669,164.43C625.686,168.772 615.357,170.868 603.68,170.868L552.031,170.868L552.031,66.073ZM602.182,143.322C609.818,143.322 615.806,141.076 620.447,136.735C624.938,132.393 627.184,126.405 627.184,118.47C627.184,110.536 624.938,104.398 620.447,100.206C615.806,95.865 609.818,93.619 602.182,93.619L587.361,93.619L587.361,143.322L602.182,143.322ZM835.614,144.669L835.614,172.065L751.629,172.065L751.629,150.358L789.504,115.326C792.798,112.182 795.044,109.637 796.092,107.392C797.14,105.146 797.738,103.05 797.738,100.954C797.738,98.409 796.84,96.314 795.193,94.816C793.397,93.469 790.852,92.721 787.558,92.721C784.414,92.721 781.42,93.619 778.576,95.266C775.731,96.912 773.636,99.308 772.138,102.452L745.491,89.128C749.533,81.642 755.371,75.654 763.006,71.312C770.641,66.971 779.923,64.875 790.852,64.875C799.086,64.875 806.421,66.222 812.859,68.917C819.296,71.612 824.237,75.504 827.829,80.445C831.422,85.385 833.219,91.224 833.219,97.661C833.219,103.499 832.021,108.889 829.626,113.829C827.081,118.919 822.29,124.608 815.254,131.046L800.283,144.669L835.614,144.669ZM901.635,108.739C909.719,110.685 916.007,114.278 920.348,119.668C924.69,124.758 926.786,131.195 926.786,138.531C926.786,144.819 925.139,150.657 921.696,156.047C918.252,161.586 912.863,165.927 905.677,169.371C898.491,172.814 889.509,174.461 878.879,174.461C871.544,174.461 864.208,173.712 856.872,172.065C849.537,170.419 843.099,168.173 837.56,165.029L849.537,138.98C853.878,141.525 858.519,143.322 863.46,144.669C868.4,146.016 873.041,146.615 877.682,146.615C881.724,146.615 885.017,145.867 887.562,144.519C890.107,143.172 891.305,141.076 891.305,138.531C891.305,133.74 887.113,131.345 878.879,131.345L864.957,131.345L864.957,109.637L880.376,93.918L842.95,93.918L842.95,67.27L921.097,67.27L921.097,88.978L901.635,108.739Z" className="fill-white" />
            <path d="M636.629,236.556L616.364,236.556L616.364,229.637L49.239,229.637C26.082,229.637 7.308,210.864 7.308,187.706L7.308,119.669L0,119.669L0,100.51L44.282,100.51L44.282,119.669L36.97,119.669L36.97,187.706C36.97,194.482 42.463,199.975 49.239,199.975L616.364,199.975L616.364,193.06L636.629,193.06L636.629,236.556ZM640.379,193.06L660.646,193.06L660.646,199.975L683.19,199.975C689.966,199.975 695.459,194.482 695.459,187.706L695.459,48.846C695.459,25.688 714.232,6.915 737.39,6.915L745.491,6.915L745.491,0L765.756,0L765.756,43.496L745.491,43.496L745.491,36.577L737.39,36.577C730.614,36.577 725.121,42.07 725.121,48.846L725.121,187.706C725.121,210.864 706.348,229.637 683.19,229.637L660.646,229.637L660.646,236.556L640.379,236.556L640.379,193.06ZM769.506,0L789.773,0L789.773,6.915L938.012,6.915C961.174,6.915 979.947,25.688 979.947,48.846L979.947,119.669L986.782,119.669L986.782,138.828L942.5,138.828L942.5,119.669L950.282,119.669L950.282,48.846C950.282,42.07 944.789,36.577 938.012,36.577L789.773,36.577L789.773,43.496L769.506,43.496L769.506,0Z" style={{ fill: "rgb(68,213,178)" }} />
            <path d="M33.014,119.669L33.014,190.892C33.014,197.542 38.404,202.931 45.053,202.931L616.364,202.931L616.364,206.681L45.053,206.681C36.333,206.681 29.264,199.613 29.264,190.892L29.264,119.669L33.014,119.669ZM972.245,119.669L972.245,48.051C972.245,38.919 968.612,30.162 962.163,23.705C955.705,17.249 946.942,13.621 937.81,13.621L789.773,13.621L789.773,9.871L937.81,9.871C947.937,9.871 957.654,13.894 964.815,21.053L964.816,21.054C971.967,28.215 975.995,37.925 975.995,48.051L975.995,119.669L972.245,119.669ZM660.646,202.931L682.208,202.931L682.472,206.681L660.646,206.681L660.646,202.931ZM718.11,183.02L718.11,53.897L721.86,53.897L721.86,183.02L718.11,183.02Z" className="fill-white" />
          </symbol>
        </defs>
      </svg>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
